import { ValidationMessage } from "@components/validationMessage";
import { withFilteredProps } from "@src/components/withFilteredProps/withFilteredProps";
import React from "react";
import styled from "styled-components";
import { palette, size } from "styled-theme";

const showValidationError = (dayMonthOrYear, fieldTouched, fieldErrors) => fieldTouched && fieldErrors && fieldTouched[dayMonthOrYear] && fieldErrors[dayMonthOrYear];

const isBaseDobNotValid = (fieldTouched, fieldErrors) => fieldTouched && fieldErrors && typeof fieldErrors === "string";

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
};

export const _DatePart = ({name, dayMonthOrYear, value, options, handleChange, handleBlur, errors, touched, className, ariaLabel}) => {
  const fieldTouched = touched[name];
  const fieldErrors = errors[name];

  return (
    <div className={className}>
      <select
        id={`${name}.${dayMonthOrYear}`}
        data-testid={`${name}.${dayMonthOrYear}`}
        className={`select-Select ${
          showValidationError(dayMonthOrYear, fieldTouched, fieldErrors) || isBaseDobNotValid(fieldTouched, fieldErrors)
            ? "required"
            : ""
        } `}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        aria-label={ariaLabel && `${ariaLabel} ${dayMonthOrYear}`}
        name={`${name}.${dayMonthOrYear}`}
      >
        <option value="">
          {capitalize(dayMonthOrYear)}
        </option>
        {options.map((item, index) => (
          <option
            key={`${new Date().getTime()}${index}`}
            value={item.value}
          >
            {item.label}
          </option>
        ))}
      </select>
      {
        showValidationError(dayMonthOrYear, fieldTouched, fieldErrors) &&
          <ValidationMessage errorMessage={fieldErrors[dayMonthOrYear]}/>
      }
    </div>
  );
};

export const DatePart = styled(_DatePart)`
  width: 100%;
  
  :not(:last-child) {
    margin-right: 5%;
  }
  
  .select-Select {
    display: flex;
    border: none;
    border-radius: 5px;
    margin: 0 !important;
    padding-left: 7px;
    padding-right: 2px;
    overflow: hidden;
    height: 38px;
    width: 100%;
    color:${palette("formInputElement", 0)};
    fill: ${palette("formInputElement", 2)};
    background-color:${palette("formInputElement", 5)};
    border: 1px solid ${palette("formInputElement", 6)};
  }
  
  .select-Select * {
    border: none;
    font-size: ${size("p0")};
  }
  
  .select-Select:focus-within {
    outline: none;
  }

  .select-Select:focus-within:not(.required) {
    box-shadow: 0 0 6px ${palette("input", 0)};
  }
  
  .required:focus-within {
    box-shadow: 0 0 6px ${palette("color", 18)};
    outline: none;
  }
  
  
  .required {
    border: 2px solid ${palette("error", 4)}!important;
  }

  
  .validation-message {
    top: 38px;
    margin-top: 5px;
  }
`;